import { render, staticRenderFns } from "./AddProjectModal.vue?vue&type=template&id=66f363ec&"
import script from "./AddProjectModal.vue?vue&type=script&lang=js&"
export * from "./AddProjectModal.vue?vue&type=script&lang=js&"
import style0 from "./AddProjectModal.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports